import { flexRender, Header } from '@tanstack/react-table';
import { MinusIcon, PlusIcon } from '@heroicons/react/24/outline';

import { useTranslation } from 'react-i18next';

export const TableHeadingCell = <T,>(header: Header<T, unknown>) => {
  const { t } = useTranslation('designSystem');
  const isGrouped = header.column.getIsGrouped();
  return (
    <th
      className={`group text-left text-sm font-medium whitespace-nowrap text-gray-600 dark:text-gray-400 ${
        header.column.getCanGroup() ? '' : 'pl-2'
      } ${isGrouped ? 'bg-gray-200 dark:bg-gray-700' : 'bg-gray-50 dark:bg-gray-800'} `}
      key={header.id}
      colSpan={header.colSpan}
    >
      {header.isPlaceholder ? null : (
        <div className={`relative flex items-center gap-2 px-2`}>
          {header.column.getCanGroup() ? (
            <button
              title={t('groupRecords')}
              onClick={header.column.getToggleGroupingHandler()}
              className="inline-flex rounded-sm p-[0.5px] ring-[1px] ring-gray-600 dark:ring-gray-400 hover:text-black dark:hover:text-white hover:ring-gray-700 dark:hover:ring-gray-400"
            >
              {header.column.getIsGrouped() ? (
                <MinusIcon className="h-[9px] w-[9px]" />
              ) : (
                <PlusIcon className="h-[9px] w-[9px]" />
              )}
            </button>
          ) : null}{' '}
          <div
            {...{
              className: `py-2 flex-grow flex items-center justify-between gap-2 ${
                header.column.getCanSort() ? 'cursor-pointer select-none ' : ''
              }`,
              onClick: header.column.getToggleSortingHandler(),
            }}
          >
            {flexRender(header.column.columnDef.header, header.getContext())}
            {header.column.getCanSort() && (
              <div className="flex flex-col gap-1 pr-1">
                <div
                  className={`h-0 w-0 rounded-md border-[5px] border-t-0 border-x-transparent ${
                    header.column.getIsSorted() &&
                    header.column.getIsSorted() === 'asc'
                      ? 'border-br-primary'
                      : 'border-gray-400 dark:border-gray-500'
                  }`}
                />
                <div
                  className={`h-0 w-0 rounded-md border-[5px] border-b-0 border-x-transparent ${
                    header.column.getIsSorted() &&
                    header.column.getIsSorted() !== 'asc'
                      ? 'border-br-primary'
                      : 'border-gray-400 dark:border-gray-500'
                  }`}
                />
              </div>
            )}
          </div>
          <div
            {...{
              onMouseDown: header.getResizeHandler(),
              onTouchStart: header.getResizeHandler(),
              className: `select-none active:bg-gray-400 dark:active:bg-gray-500 absolute h-full right-0 group flex-grow w-[0px] group-hover:w-[6px] active:w-[6px] bg-gray-200 dark:bg-gray-700 ml-auto cursor-col-resize ${
                header.column.getIsResizing() ? 'isResizing' : ''
              }`,
            }}
          ></div>
        </div>
      )}
    </th>
  );
};
